<header role="banner" class="header">
  <div class="container">
    <a [routerLink]="'/'" class="header__logo">SCAREDDIT</a>
    <nav role="navigation" class="header__navigation">
      <a [routerLink]="'/about'" class="header__navigation__link">About</a>
    </nav>
  </div>
</header>
